import WidgetsMgr from 'widgets/widgetsMgr';

WidgetsMgr.addWidgetsList('app_flagship_tasting_room', () => []);
